import React, { createRef, useEffect } from "react";
import { withRouter, Redirect } from "react-router-dom";

//Utils
import { mapPageNav, mapPageNavMobile } from "../../../Utils/Utils";

const Hero = (props) => {
  const { pathname } = props.location;

  const sliderRef = createRef();
  const { params } = props.match;

  useEffect(() => {
    switch (params.category) {
      case "service-areas":
        sliderRef.current.innerSlider.slickGoTo(1);
        break;
      case "financing":
        sliderRef.current.innerSlider.slickGoTo(2);
        break;
      default:
        sliderRef.current.innerSlider.slickGoTo(0);
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const links = [
    {
      title: "Our Team",
      destination: `/about-us`,
    },
    {
      title: "Service Areas",
      destination: `/about-us/service-areas`,
    },
    {
      title: "Financing",
      destination: `/about-us/financing`,
    },
  ];
  console.log(params);

  return (
    <>
      <div className="row justify-content-center panel-hero">
        {pathname === "/services" ? <Redirect to="/about-us" /> : null}
        <div className="col-12 hero-unit">
          <h1 className="text-uppercase text-center">{
            params.category === 'service-areas'? "Service Areas" : params.category === 'financing' ? "Financing" : "About Us"
            }</h1>
        </div>
        <div className="col-lg-11 col-xl-10">
          <div className="row page-navigation mobile-hidden">
            {mapPageNav(links, pathname)}
          </div>
        </div>
        <div className="page-navigation desktop-hidden">
          {mapPageNavMobile(links, pathname, sliderRef, props.history)}
        </div>
      </div>
    </>
  );
};

export default withRouter(Hero);
